import {LOGIN_REQUEST,
        LOGIN_SUCCESS,
        LOGIN_FAILURE,
        LOGOUT} from '../constants/ActionTypes';

let user = JSON.parse(localStorage.getItem('user'));

const initialState = user ? { loggedIn: true, user } : {};

export default function authentication(state = initialState, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                loggingIn: true,
            };
        case LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user
            };
        case LOGIN_FAILURE:
            return {};
        case LOGOUT:
            return {};
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/authentication.js